// src/components/ServicesSection.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ServicesSection.css';
import servicesData from './ServiceData'; // Update this path based on your directory structure
import star from "../assets/imgs/fissstar.svg";
import '../App.css'

const ServicesSection = () => {
    let navigate = useNavigate();

    return (
        <section className="our-services bg-light py-5">
            <Container>
                <Row className="service-section-row">
                    <Col xs={12} className="text-center">
                        <h1>Our Services</h1>
                    </Col>
                    {servicesData.map(service => (
                        <ServiceCard key={service.id} service={service} navigate={navigate} />
                    ))}
                </Row>
            </Container>
        </section>
    );
};

const ServiceCard = ({ service, navigate }) => (
    <Col lg={3} md={6} sm={12} xl={3} className="mb-4 services-details">
        <div className="text-center p-4 card-background">
            <img src={service.images[0]} alt={service.title} className="img-fluid" />
            <h6 className=" mt-3">{service.title}</h6>
            <p className="starting-from-h">Starting from $100</p>
            <div className="d-flex justify-content-between align-items-center">
                <p className="mt-3">5.0 <img src={star} width="18px" height="18px" className="ml-2 mb-1" alt="Rating" /></p>
                <Button variant="success" className="show-details" onClick={() => navigate(`/service/${service.id}`)}>
                    Show Details
                </Button>
            </div>
        </div>
    </Col>
);

export default ServicesSection;
